import styles from "./topbar.module.scss";
import { Box, Typography } from "@mui/material";
import { useConsole, usePremium } from "contexts";
import { topbarRoutes } from "data/routes";
import { useParams, usePathname, useRouter } from "next/navigation";
import { Flex, IconButton, Image } from "ui";
import LoginMenu from "views/login/LoginMenu";
import Routes from "data/routes";
import Account from "./Account";
import Modal from "./Modal";

const Topbar = () => {
  const { currentPath, isStandalone, screen } = useConsole();
  const { isPremium } = usePremium();
  const pathname = usePathname();
  const params = useParams();
  const router = useRouter();

  const loginPaths = [Routes.login, Routes.register];
  const isLoginPath = loginPaths.includes(pathname);

  if (
    screen.isMobile ||
    (isStandalone && screen.orientation === "portrait") ||
    (params?.bid && (screen.isTablet || screen.isLandscape))
  )
    return null;

  return (
    <Flex
      className={styles.root}
      component="nav"
      justifyContent="space-between"
    >
      <Box className={styles.logo}>
        <Image src="/isotipo.svg" alt="Logo" width={40} height={40} />
        <Typography variant="body1">monus</Typography>
        <Typography variant="span">{isPremium && "premium"}</Typography>
      </Box>
      <Flex className={styles.navbar} component="ul">
        {!isLoginPath &&
          topbarRoutes.map(({ href, icon, activePaths }) => (
            <IconButton
              key={href}
              active={activePaths?.includes(
                currentPath?.replace(params?.bid, "[bid]")
              )}
              color="inherit"
              component="li"
              icon={icon}
              onClick={() => router.push(href)}
              rounded
            />
          ))}
        <LoginMenu>
          <Modal>
            <Account isPremium={isPremium} />
          </Modal>
        </LoginMenu>
      </Flex>
    </Flex>
  );
};

export default Topbar;
